export default "__VITE_ASSET__l$sNyhlP__"